/* Product page — variant picker, gallery, dock bar, share.
   The variant list comes from Liquid; option changes resolve a variant, update
   the price, availability, gallery and URL without a page load. */
(function () {
  'use strict';

  var Sloos = window.Sloos || {};

  if (!customElements.get('product-info')) {
    customElements.define(
      'product-info',
      class ProductInfo extends HTMLElement {
        connectedCallback() {
          try {
            this.variants = JSON.parse(this.dataset.variants);
          } catch (e) {
            this.variants = [];
          }

          this.sectionId = this.dataset.sectionId;
          this.form = this.querySelector('[data-product-form]');
          this.idInput = this.querySelector('[data-variant-id]');

          this.addEventListener('change', this.onChange.bind(this));

          this.initZoom();
          this.initShare();
        }

        /* ---------------- Variants ---------------- */

        selectedOptions() {
          var values = [];
          this.querySelectorAll('[data-option-input]:checked').forEach(function (input) {
            values[parseInt(input.dataset.optionInput, 10)] = input.value;
          });
          return values;
        }

        onChange(event) {
          if (!event.target.matches('[data-option-input]')) return;

          var chosen = this.selectedOptions();
          var variant = this.variants.find(function (candidate) {
            return candidate.options.every(function (option, index) {
              return option === chosen[index];
            });
          });

          this.paintOptionNames(chosen);
          this.applyVariant(variant);
        }

        paintOptionNames(chosen) {
          this.querySelectorAll('[data-option-value]').forEach(function (node) {
            var index = parseInt(node.dataset.optionValue, 10);
            if (chosen[index]) node.textContent = chosen[index];
          });
        }

        applyVariant(variant) {
          if (!variant) {
            if (this.idInput) this.idInput.value = '';
            this.setButtons(true, Sloos.strings.unavailable);
            return;
          }

          if (this.idInput) {
            this.idInput.value = variant.id;
            this.idInput.disabled = false;
          }

          this.setButtons(
            !variant.available,
            variant.available ? Sloos.strings.addToCart : Sloos.strings.soldOut
          );

          this.updatePrice(variant);
          this.updateDock(variant);
          this.updateUrl(variant);
          this.showVariantMedia(variant);
        }

        setButtons(disabled, label) {
          [this.querySelector('[data-add-button]'), document.querySelector('[data-dock-add]')].forEach(function (button) {
            if (!button) return;
            button.disabled = disabled;
            var span = button.querySelector('[data-add-label]');
            if (span) span.textContent = label;
          });
        }

        updatePrice(variant) {
          var host = this.querySelector('[data-product-price] .price');
          if (!host) return;

          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          host.classList.toggle('price--on-sale', !!onSale);

          var now = host.querySelector('.price__now');
          if (now) now.textContent = Sloos.formatMoney(variant.price);

          var was = host.querySelector('.price__was');
          if (onSale) {
            if (!was) {
              was = document.createElement('span');
              was.className = 'price__was';
              host.insertBefore(was, host.firstChild);
            }
            was.textContent = Sloos.formatMoney(variant.compare_at_price);
          } else if (was) {
            was.remove();
          }
        }

        updateDock(variant) {
          var price = document.querySelector('[data-dock-price]');
          if (price) price.textContent = Sloos.formatMoney(variant.price);

          var meta = document.querySelector('[data-dock-meta]');
          if (meta) meta.textContent = (variant.title || '').replace('Default Title', '');
        }

        updateUrl(variant) {
          if (!this.dataset.productUrl) return;
          var url = this.dataset.productUrl + '?variant=' + variant.id;
          window.history.replaceState({}, '', url);
        }

        showVariantMedia(variant) {
          if (!variant.featured_media) return;
          /* The gallery is driven by radios now, so selecting a variant just
             ticks the one holding that photograph. */
          var radio = this.querySelector(
            '.product__slide-radio[data-media-id="' + variant.featured_media.id + '"]'
          );
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        /* ---------------- Gallery ---------------- */

        /* The gallery swap deliberately does NOT live here. It is a document
           level handler in theme.js, so switching photos keeps working even if
           this custom element never upgrades — product.js failing to load took
           the thumbnails down with it, silently. */

        /* ---------------- Zoom ----------------
           Pointer devices magnify in place, following the cursor. Touch has no
           hover, so a tap magnifies in place too and a second tap returns —
           it used to open a full-screen image with nothing but a close button,
           which read as "a photo appeared and I can only exit". */

        initZoom() {
          this.stage = this.querySelector('[data-zoom]');
          if (!this.stage) return;

          this.zoomLayer = this.stage.querySelector('[data-zoom-layer]');
          if (!this.zoomLayer) return;

          var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

          this.stage.addEventListener('mouseenter', function () {
            if (!fine.matches) return;
            this.zoomIn();
          }.bind(this));

          this.stage.addEventListener('mousemove', function (event) {
            if (!fine.matches || !this.stage.classList.contains('is-zoomed')) return;
            this.trackZoom(event.clientX, event.clientY);
          }.bind(this));

          this.stage.addEventListener('mouseleave', function () {
            if (!fine.matches) return;
            this.zoomOut();
          }.bind(this));

          /* Touch: tap to magnify at the point touched, tap again to go back.
             Dragging while zoomed pans the image rather than scrolling it. */
          this.stage.addEventListener('click', function (event) {
            if (fine.matches) return;

            if (this.stage.classList.contains('is-zoomed')) {
              this.zoomOut();
            } else {
              this.zoomIn();
              this.trackZoom(event.clientX, event.clientY);
            }
          }.bind(this));

          this.stage.addEventListener(
            'touchmove',
            function (event) {
              if (fine.matches || !this.stage.classList.contains('is-zoomed')) return;
              var touch = event.touches[0];
              if (!touch) return;
              event.preventDefault();
              this.trackZoom(touch.clientX, touch.clientY);
            }.bind(this),
            { passive: false }
          );
        }

        /* Each slide carries its own high-resolution source; zoom follows
           whichever radio is checked rather than one value on the stage. */
        currentZoomSrc() {
          var checked = this.querySelector('.product__slide-radio:checked');
          var index = checked ? checked.value : '0';
          var slide = this.querySelector('.product__slide[data-slide="' + index + '"]');
          return (slide && slide.dataset.zoomSrc) || this.stage.dataset.zoomSrc;
        }

        zoomIn() {
          var source = this.currentZoomSrc();
          if (!source) return;
          this.zoomLayer.style.backgroundImage = 'url("' + source + '")';
          this.stage.classList.add('is-zoomed');
        }

        zoomOut() {
          this.stage.classList.remove('is-zoomed');
        }

        trackZoom(clientX, clientY) {
          var box = this.stage.getBoundingClientRect();
          var x = ((clientX - box.left) / box.width) * 100;
          var y = ((clientY - box.top) / box.height) * 100;
          this.zoomLayer.style.backgroundPosition =
            Math.min(100, Math.max(0, x)) + '% ' + Math.min(100, Math.max(0, y)) + '%';
        }

        /* ---------------- Share ---------------- */

        initShare() {
          var button = this.querySelector('[data-copy-share]');
          if (!button) return;

          button.addEventListener('click', function () {
            var input = button.previousElementSibling;
            if (!input) return;
            input.select();
            if (navigator.clipboard) navigator.clipboard.writeText(input.value);
            else document.execCommand('copy');

            var original = button.textContent;
            button.textContent = '✓';
            setTimeout(function () {
              button.textContent = original;
            }, 1600);
          });
        }
      }
    );
  }
})();
